import './themeDefaults';
import { ComposedTheme, createUseStyles } from '@glu/theming';

import { ITooltipProps } from 'Tooltip';

type TStyleProps = Pick<ITooltipProps, 'variant' | 'transparency'>;

export const arrowHeight = 12;

export default createUseStyles(
  ({
    tooltip: {
      backgroundColor: { primaryBackgroundColor, secondaryBackgroundColor },
      borderRadius,
      boxShadow,
      color: { primaryColor, secondaryColor },
      fontFamily,
      fontSize,
    },
    zIndex: { tooltip },
  }: ComposedTheme) => ({
    arrow: {
      height: arrowHeight,
      overflow: 'hidden',
      width: arrowHeight,
      position: 'absolute',
      background: 'inherit',
      visibility: 'hidden',
      '&::after': {
        background: 'inherit',
        boxShadow,
        content: "''",
        height: arrowHeight,
        width: arrowHeight,
        position: 'absolute',
        visibility: 'visible',
      },
    },
    root: {
      '&[data-popper-out-of-boundaries]': {
        display: 'none',
      },
      '&[data-popper-placement^="top"] $arrow': {
        '&::after': {
          transform: 'translateX(50%) translateY(-50%) rotate(45deg)',
        },
        bottom: -arrowHeight,
      },
      '&[data-popper-placement^="bottom"] $arrow': {
        '&::after': {
          transform: 'translateX(50%) translateY(50%)  rotate(45deg)',
        },
        top: -arrowHeight,
      },
      '&[data-popper-placement^="bottom"] $arrow, &[data-popper-placement^="top"] $arrow': {
        width: arrowHeight * 2,
      },
      '&[data-popper-placement^="left"] $arrow': {
        '&::after': {
          transform: 'translateX(-50%) translateY(50%)  rotate(45deg)',
        },
        right: -arrowHeight,
      },
      '&[data-popper-placement^="right"] $arrow': {
        '&::after': {
          transform: 'translateX(50%) translateY(50%)  rotate(45deg)',
        },
        left: -arrowHeight,
      },
      '&[data-popper-placement^="left"] $arrow, &[data-popper-placement^="right"] $arrow': {
        height: arrowHeight * 2,
      },
      background: ({ variant }: TStyleProps) =>
        variant === 'primary' ? primaryBackgroundColor : secondaryBackgroundColor,
      color: ({ variant }: TStyleProps) => (variant === 'primary' ? primaryColor : secondaryColor),
      borderRadius,
      boxShadow,
      display: 'none',
      fontSize,
      fontFamily,
      padding: 16,
      position: 'absolute',
      opacity: ({ transparency }: TStyleProps) => (transparency === 'solid' ? 1 : 0.8),
      zIndex: tooltip,
      maxWidth: 350,
      '&[data-show]': {
        display: 'block',
      },
    },
  })
);
